<ng-container *ngIf="isLoggedIn; else notLoggedIn">
  <ng-container *ngIf="hasAuthorizationError; else checkInitialized">
    <div class="application-common-container full-screen-center">
      <div class="centered-content authorization-error"
           data-cy="auth-error">
        <p>You are not authorized to access this application.</p>
        <p>Please contact your administrator.</p>
      </div>
    </div>
  </ng-container>
  <ng-template #checkInitialized>
    <ng-container *ngIf="isInitialized; else settingLoading">
      <router-outlet></router-outlet>
    </ng-container>
    <ng-template #settingLoading>
      <div class="application-common-container full-screen-center initializing-loader">
        <div class="centered-content"> INITIALIZING <mat-progress-bar mode="buffer"></mat-progress-bar>
        </div>
      </div>
    </ng-template>
  </ng-template>
</ng-container>
<ng-template #notLoggedIn>
  <div *ngIf="!authenticating"
       class="application-common-container full-screen-center">
    <button class="login-button"
            (click)="onLoginClicked()">LOGIN</button>
  </div>
  <div *ngIf="authenticating"
       class="application-common-container full-screen-center authenticating-loader">
    <div class="centered-content"> AUTHENTICATING <mat-progress-bar mode="buffer"></mat-progress-bar>
    </div>
  </div>
</ng-template>